/* eslint-disable react/display-name */
import * as React from "react";
import { connect } from "react-redux";
import { formatDate } from "../../../../../../utils/DateFormat";
import { DetailModal } from "../DetailModalBookingPeriod";
import { Modal } from "@vwpfs/mary-air-lib/components/air/06-molecules/Modal";
import { Pagination } from "@vwpfs/mary-air-lib/components/air/06-molecules/Pagination";
import { RowData, Table, TableData } from "@vwpfs/mary-air-lib/components/air/06-molecules/Table";
import { SubPageDisplay, SubPages } from "../../../../../../store/AppDisplays";
import { RevisionTypeDisplay } from "../../../../../../store/AuditTrail/Displays";
import { AuditTrails } from "../../../../../../store/AuditTrail/Types";
import { BookingPeriod } from "../../../../../../store/BookingPeriod/Types";
import { ReduxState, isRemoteLoading } from "../../../../../../store/ReduxState";
import { remoteTrigger, remoteClearResponse, remoteClearError } from "../../../../../../store/RemoteActions";
import { RemoteScope } from "../../../../../../store/RemoteTypes";
import { ThemeSize, ThemePalette, ThemeShadowSizes, ThemeBreakpoints } from "@vwpfs/mary-air-lib/theme/_Types";
import { modalShow } from "../../../../../../utils/redux/ActionTypes";
import { getRevisionTypeColor } from "../../../../../utils/FormatHelpers";
import { Header } from "@vwpfs/mary-air-lib/components/air/09-views/01-sections/Header";
import { Page } from "@vwpfs/mary-air-lib/components/air/09-views/01-sections/Page";
import { Alignment, ButtonsWrapper, Orientation } from "@vwpfs/mary-air-lib/components/air/06-molecules/ButtonsWrapper";
import { RouteComponentProps } from "react-router";
import { Container } from "@vwpfs/mary-air-lib/components/air/03-base/Container";
import { Div } from "@vwpfs/mary-air-lib/components/air/03-base/Div";
import { LoadingIndications, LoadingIndicator } from "@vwpfs/mary-air-lib/components/air/05-atoms/LoadingIndicator";
import { Badge } from "@vwpfs/mary-air-lib/components/air/05-atoms/Badge";
import { Button } from "@vwpfs/mary-air-lib/components/air/05-atoms/Button";
import { IconNames } from "@vwpfs/mary-air-lib/components/air/05-atoms/Icon";
import { DispatchFunc } from "../../../../../../store/ActionTypes";

interface Params {
    periodId: string;
}

/**
 *
 */
interface StateProps {
    params: Params;
    results: AuditTrails;
    loading: boolean;
}

/**
 *
 */
interface DispatchProps {
    loadResults: (id: string, skip: number) => void;
    clearResults: () => void;
    openDetail: (period: BookingPeriod) => void;
}

/**
 *
 */
type Props = DispatchProps & StateProps;

export const OpenDetailRequest = (period: BookingPeriod) => (
    () => (
        <Modal
            modalID={period.id.toString()}
            theme={{ size: ThemeSize.SMALL }}
        >
            <DetailModal
                modalID={period.id.toString()}
                period={period}
            />
        </Modal>
    )
);

/**
 *
 * @param s
 */
const mapStateToProps = (s: ReduxState, p: RouteComponentProps): StateProps => ({
    params: p.match.params as Params,
    results: s.prop("remote").prop(RemoteScope.AUDIT_TRAIL_BOOKING_PERIOD) as AuditTrails,
    loading: isRemoteLoading(s, RemoteScope.AUDIT_TRAIL_BOOKING_PERIOD),
});

/**
 *
 */
export const mapDispatchToProps = (dispatch: DispatchFunc): DispatchProps => ({
    loadResults: (id: string, skip: number) => dispatch(remoteTrigger(RemoteScope.AUDIT_TRAIL_BOOKING_PERIOD, {
        id: id,
        skip: skip,
    })),
    clearResults: () => (
        dispatch(remoteClearResponse(RemoteScope.AUDIT_TRAIL_BOOKING_PERIOD)),
        dispatch(remoteClearError(RemoteScope.AUDIT_TRAIL_BOOKING_PERIOD))
    ),
    openDetail: (period: BookingPeriod) => {
        dispatch(
            modalShow(
                period.id.toString(),
                OpenDetailRequest(period),
            ),
        );
    },
});

/**
 *
 */
export class BookingPeriodAuditTrailDetailComp
    extends React.Component<Props, {}> {

    /**
     *
     * @param props
     * @param ctx
     */
    public constructor(props: Props, ctx?: {}) {
        super(props, ctx);
        this.handlePageClick = this.handlePageClick.bind(this);
        this.getProcessedRows = this.getProcessedRows.bind(this);
        this.resultsData = this.resultsData.bind(this);
        this.openDetail = this.openDetail.bind(this);
    }

    public componentDidMount() {
        this.props.loadResults(this.props.params.periodId, 0);
    }

    public componentWillUnmount() {
        this.props.clearResults();
    }

    /**
     *
     */
    public render() {
        return (
            <Page>
                <Container
                    theme={{
                        padding: {
                            "": { y: 3 },
                            "sm": { y: 4 },
                        },
                    }}
                >
                    <Header
                        title={SubPageDisplay[SubPages.AUDIT_TRAIL_BOOKING_PERIOD_DETAIL].title}
                        description={SubPageDisplay[SubPages.AUDIT_TRAIL_BOOKING_PERIOD_DETAIL].description}
                        goBack={SubPageDisplay[SubPages.AUDIT_TRAIL_BOOKING_PERIOD].path}
                    />
                    {this.props.loading ?
                        <LoadingIndicator
                            type={LoadingIndications.DEFAULT}
                            theme={{ palette: ThemePalette.BRAND_PRIMARY }}
                        /> :
                        <Div
                            theme={{
                                shadow: ThemeShadowSizes.TINY,
                                palette: ThemePalette.CONTRAST_PRIMARY,
                            }}
                        >
                            <Table
                                hasActions
                                data={{
                                    columns: this.resultsData().columns,
                                    rows: this.resultsData().rows,
                                    sort: this.resultsData().sort,
                                }}
                            />
                            {(this.props.results?.totalPages && this.props.results?.totalPages > 1) ?
                                <Div
                                    className="scl-h-text-align--center"
                                    theme={{
                                        padding: { "": { t: 3, b: 2 }, "sm": { t: 4, b: 3 } },
                                    }}
                                >
                                    <Pagination
                                        pageCount={this.props.results.totalPages}
                                        currentPage={this.props.results.number}
                                        onPageChange={this.handlePageClick}
                                        theme={{ palette: ThemePalette.CONTRAST_PRIMARY }}
                                    />
                                </Div> : null}
                        </Div>}
                </Container>
            </Page>
        );
    }

    private handlePageClick(skip: number) {
        this.props.loadResults(this.props.params.periodId, skip);
    }

    /**
     *
     */
    private getProcessedRows(): RowData[] {
        return this.props.results?.content.map((row, index) => {
            const gl = row.entity as BookingPeriod;
            return ({
                id: `${row.entity.id}${index}`,
                data: [
                    (
                        <Badge
                            key={`badge-${row.entity.id}`}
                            theme={{ paletteState: getRevisionTypeColor(row.metadata.revisionType) }}>
                            {RevisionTypeDisplay[row.metadata.revisionType]}
                        </Badge>
                    ),
                    row.metadata.delegate.user,
                    <span key={`revision-date${index}`}>
                        {formatDate(new Date(row.metadata.delegate.revisionDate), "DD-MM-YYYY HH:mm:ss")}
                    </span>,
                    <ButtonsWrapper
                        key={`navlink-${row.entity.id}`}
                        asGroup
                        alignment={Alignment.RIGHT}
                        defaultOrientation={Orientation.HORIZONTAL}
                        orientations={{
                            [ThemeBreakpoints.XS]: Orientation.VERTICAL,
                            [ThemeBreakpoints.MD]: Orientation.HORIZONTAL,
                        }}
                    >
                        <Button
                            key={`btn-${row.entity.id}`}
                            icon={IconNames.VIEW}
                            theme={{
                                palette: ThemePalette.CONTRAST_PRIMARY,
                                shadow: ThemeShadowSizes.TINY,
                            }}
                            link={{ onClick: this.openDetail(gl) }}
                        /></ButtonsWrapper>,
                ],
            });
        });
    }

    private openDetail(period: BookingPeriod) {
        return () => this.props.openDetail(period);
    }

    /**
     *
     */
    private resultsData(): TableData {
        return {
            sort: undefined,
            columns: [
                {
                    label: "Revision type",
                },
                {
                    label: "User",
                },
                {
                    label: "Revision date",
                },
                {
                    label: "Actions",
                },
            ],
            rows: this.getProcessedRows(),
        };
    }
}

/**
 *
 */
export const BookingPeriodAuditTrailDetail = connect(
    mapStateToProps,
    mapDispatchToProps,
)((props: Props) => <BookingPeriodAuditTrailDetailComp {...props}/>);
